import React from 'react';
import styled from 'styled-components';
import { DatePickerInput, Dropdown } from '@leapeasy/ui-kit';

import {
  POLICY_ISSUED_DATE_RANGE_PRESETS,
  normalizePolicyIssuedDateRangeFilter,
} from 'utils/policyIssuedDateRangeFilter';

const PRESET_OPTIONS = [{ text: 'All', value: '' }, ...POLICY_ISSUED_DATE_RANGE_PRESETS];

export function PolicyIssuedDateRangeFilterFields({ label = 'Issued Date', value, onChange }) {
  const normalized = normalizePolicyIssuedDateRangeFilter(value);
  const presetValue = normalized.preset || '';

  const handlePresetChange = (event) => {
    const nextPreset = event.target.value || null;
    if (!nextPreset) {
      onChange({ preset: null, startDate: null, endDate: null });
      return;
    }

    if (nextPreset === 'custom') {
      onChange({
        preset: 'custom',
        startDate: normalized.startDate,
        endDate: normalized.endDate,
      });
      return;
    }

    onChange({ preset: nextPreset, startDate: null, endDate: null });
  };

  return (
    <FilterBlock>
      <Dropdown
        onChange={handlePresetChange}
        options={PRESET_OPTIONS}
        value={presetValue}
        multiselect={false}
        showSearch={false}
        placeholder="All"
        label={label}
        style={{ width: '100%' }}
      />
      {normalized.preset === 'custom' ? (
        <RangeDatePickerContainer>
          <DatePickerInput
            label={`${label} from`}
            size="small"
            value={normalized.startDate || ''}
            maxDate={normalized.endDate || undefined}
            onChange={(date) => {
              onChange({
                preset: 'custom',
                startDate: date.target.value,
                endDate: normalized.endDate,
              });
            }}
          />
          <DatePickerInput
            label={`${label} to`}
            size="small"
            value={normalized.endDate || ''}
            minDate={normalized.startDate || undefined}
            onChange={(date) => {
              onChange({
                preset: 'custom',
                startDate: normalized.startDate,
                endDate: date.target.value,
              });
            }}
          />
        </RangeDatePickerContainer>
      ) : null}
    </FilterBlock>
  );
}

const FilterBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const RangeDatePickerContainer = styled.div`
  display: flex;
  max-width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;

  * {
    box-sizing: border-box;
  }

  & > div {
    width: 100% !important;
  }

  .ui-kit-input-body {
    width: 278px;
  }
`;
